import { COLORS, Text, nFormatter } from "@asayinc/component-library";
import { Box, Popover, Stack } from "@mui/material";
import { Card } from "src/components/atoms/Card";
import { IGraphDotStat } from "../types";

export interface IActiveDotState extends IGraphDotStat {
  anchorEl: SVGSVGElement;
}

interface IProps {
  open: boolean;
  handleClose: () => void;
  activeMailing: IActiveDotState | null;
  sharesMax: number;
  customerMax: number;
}

export const MailingPopover = ({
  open,
  handleClose,
  activeMailing,
  sharesMax,
  customerMax,
}: IProps) => {
  return (
    <Popover
      id="mailing-popover"
      open={open}
      anchorEl={activeMailing?.anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      sx={{
        pointerEvents: "none",
      }}
    >
      <Card title="" sx={{ px: 4, py: 3, borderRadius: 2 }}>
        {activeMailing &&
          activeMailing.shares !== undefined &&
          activeMailing.customers !== undefined && (
            <>
              <Text variant="subtitle3" sx={{ mb: 0.5 }}>
                {activeMailing.name}
              </Text>
              <Text
                variant="body3"
                sx={{ mb: 1.5, color: COLORS.P_MED_EMPHASIS }}
              >
                Total {activeMailing.range}:
              </Text>
              <Stack direction="row" alignItems="center" mb={1}>
                <Box
                  sx={{
                    bgcolor: COLORS.DATA_VIZ_DARK_GREEN,
                    width: 8,
                    height: 8,
                    borderRadius: "100%",
                    mr: 2,
                  }}
                />
                <Text variant="body3">
                  {nFormatter(activeMailing.shares || 0)} shares (
                  {sharesMax > 0
                    ? Math.round(
                        (activeMailing.shares / sharesMax) * 100 * 100
                      ) / 100
                    : 0}
                  %)
                </Text>
              </Stack>
              <Stack direction="row" alignItems="center">
                <Box
                  sx={{
                    bgcolor: COLORS.DATA_VIZ_GOLD,
                    width: 8,
                    height: 8,
                    borderRadius: "100%",
                    mr: 2,
                  }}
                />
                <Text variant="body3">
                  {nFormatter(activeMailing.customers || 0)} customers (
                  {customerMax > 0
                    ? Math.round(
                        (activeMailing.customers / customerMax) * 100 * 100
                      ) / 100
                    : 0}
                  %)
                </Text>
              </Stack>
            </>
          )}
      </Card>
    </Popover>
  );
};
